<template>
  <div id="root">
    <div id="app" class="logged-in">
      <div id="nav" class="mobileRoomTopNav_3gjO3">
        <div class="content_1QLZB">
          <div class="right_1XMld">
            <h3 style="color:white;margin-right: 15px;font-weight: bold;" class="pageTitle_36g65">
              به خانواده بزرگ روبو بپیوند!
            </h3>
          </div>
          <div :style="isMobile == true ? 'margin-left:20px;' : 'margin-left:30px'" class="left_3cl7J">
            <button @click="$router.back()" class="p-button p-component tu-button btn-tertiary backBtn_U6DGe" type="button">
              <i class="fa-solid fa-arrow-left" style="font-size:20px;color:rgb(209, 208, 208)"></i>
            </button>
          </div>
        </div>
      </div>
      <div id="app-menu">
        <div id="app-menu-content-wrapper">
          <div id="app-menu-content">
            <!-- <div id="tools-section" class="menu-section" style="margin-bottom:20px">
              <div style="display:flex;justify-content:space-between;margin-bottom:10px;">
                <div class="menu-section-title">
                  <i class="fa-solid fa-gift" style="font-size: 15px;" aria-hidden="true"></i>
                  <span class="menu-section-title-text">کوکی رایگان</span>
                </div>
              </div>
              <span style="line-height:20px;font-size:15px;font-weight:200;font-family: IRANSansWeb;color:white">
                شما میتوانید از تمامی امکانات روبو به طور رایگان و تا 5 کوکی که به طور روزانه دریافت میکنید، استفاده نمایید.
                درصورتی که به کوکی🍪 بیشتری نیاز داشته باشید میتوانید با تهیه بسته های کوکی🍪 از مزایای ویژه آن استفاده کنید.
              </span>
              <br />
              <br />
            </div>  -->
            <div id="tools-section" style="margin-top: 0px;" class="menu-section" >
              <div style="display:flex;justify-content:space-between;margin-bottom:10px;">
                <div class="menu-section-title">
                  <i class="fa-solid fa-gift" style="font-size: 15px;" aria-hidden="true"></i>
                  <span class="menu-section-title-text">باهم در کنار هم</span>
                </div>
              </div>
              <span style="line-height:20px;font-size:15px;font-weight:200;font-family: IRANSansWeb;color:white">
               تخفیف حمایتی شرایط ویژه:
              </span>
              <br />
              <br />
            </div> 
            <div id="tools-section" class="menu-section" style="margin-bottom:20px;margin-top: 0px;">
              <div style="display:flex;justify-content:space-between">
                <div class="menu-section-title">
                  <i class="fa-solid fa-basket-shopping" aria-hidden="true"></i>
                  <span class="menu-section-title-text">بسته های کوکی</span>
                </div>
              </div>
              <!-- Tabbed subscription period selector -->
              <div class="subscription-tabs">
    <button 
      :class="{'tab-button': true, 'active': selectedPeriod === 1}"
      @click="setSubscriptionPeriod(1)">
      1 ماهه <span class="discount-badge">%20</span>
    </button>
    <button
      :class="{'tab-button': true, 'active': selectedPeriod === 3}"
      @click="setSubscriptionPeriod(3)">
      3 ماهه <span class="discount-badge">%30</span>
    </button>
    <!-- <button
      :class="{'tab-button': true, 'active': selectedPeriod === 6}"
      @click="setSubscriptionPeriod(6)">
      6 ماهه <span class="discount-badge">%40</span>
    </button> -->
    <button
      :class="{'tab-button': true, 'active': selectedPeriod === 12}"
      @click="setSubscriptionPeriod(12)">
      1 ساله <span class="discount-badge">%50</span>
    </button>
  </div>
            </div>

            <!-- Package Cards -->
            <!-- Card for Package 1 -->
            <div :style="isMobile == true ? 'display:flex;padding: 10px;background-color: #303030;border-radius: 10px;box-shadow: 2px 2px 4px rgba(black, 0.25);' : 'display:flex;padding: 10px;background-color: #303030;border-radius: 10px;box-shadow: 2px 2px 4px rgba(black, 0.25);width:400px;height:170px'">
              <img
                :style="isMobile == true ? 'border-radius: 10px;margin-top:13px;width:30vw;height:30vw;margin-right:5px;' : 'border-radius: 10px;margin-top:5px;margin-right:5px;'"
                :src="require('@/assets/img/cookiejar.jpg')" />
              <div style="padding:5px;margin-right:10px;width:100%">
                <div>
                  <span style="font-size:17px;font-weight:bold;font-family: IRANSansWeb;color:white">
                    جعبه کوکی🍪
                  </span>
                </div>
                <div style="margin-top: 5px;margin-right:5px;">
                  <span style="font-size:14px;font-weight:800;font-family: IRANSansWeb;color:white">
                    {{ this.selectedPeriod * 500 }} کوکی🍪
                  </span>
                  <p style="font-size:14px;font-weight:800;font-family: IRANSansWeb;color:white">
                    دسترسی با اینترنت ملی
                  </p>
                 
                </div>
                <div style="margin-top: 10px;display:grid">
 
    <span style="font-size:15px;text-decoration: line-through;color:#ff002b;margin-right:5px;">
      ماهانه: {{ package1Prices[0].toLocaleString() }} تومان
    </span>
    <span style="font-size:17px;font-weight:bold;font-family: IRANSansWeb;color:#a397fa">
      ماهانه: {{ displayPricePackage1 }} تومان
    </span>
</div>
                <div @click="showPackage1()"
                  style="display: flex;justify-content: end;margin-top: 10px;text-align: end;cursor: pointer;">
                  <div
                    style="padding:5px;border-radius: 5px;background-color: #E23E57;width:90px;color:white;font-weight: bold;font-size:15px">
                    خرید
                    <i style="padding: 10px;color:white" class="fa-solid fa-angles-left"></i>
                  </div>
                </div>
              </div>
            </div>

            <!-- Card for Package 3 -->
            <div
              :style="isMobile == true ? 'display:flex;padding: 10px;background-color: #303030;border-radius: 10px;box-shadow: 2px 2px 4px rgba(black, 0.25);margin-top :15px' : 'display:flex;padding: 10px;background-color: #303030;border-radius: 10px;box-shadow: 2px 2px 4px rgba(black, 0.25);width:400px;height:170px;margin-top :15px'">
              <img
                :style="isMobile == true ? 'border-radius: 10px;margin-top:13px;width:30vw;height:30vw;margin-right:5px;' : 'border-radius: 10px;margin-top:5px;margin-right:5px;'"
                :src="require('@/assets/img/cookiechest.jpg')" />
              <div style="padding:5px;margin-right:10px;width:100%">
                <div>
                  <span style="font-size:17px;font-weight:bold;font-family: IRANSansWeb;color:white">
                    صندوق کوکی🍪
                  </span>
                </div>
                <div style="margin-top: 5px;margin-right:5px">
                  <span style="font-size:14px;font-weight:800;font-family: IRANSansWeb;color:white">
                    {{ this.selectedPeriod * 1500 }} کوکی🍪
                  </span>
                  <p style="font-size:14px;font-weight:800;font-family: IRANSansWeb;color:white">
                    دسترسی با اینترنت ملی
                  </p>
                </div>
                <div style="margin-top: 10px;display:grid">
  
    <span style="font-size:15px;text-decoration: line-through;color:#ff002b;margin-right:5px;">
      ماهانه: {{ package3Prices[0].toLocaleString() }} تومان
    </span>
    <span style="font-size:17px;font-weight:bold;font-family: IRANSansWeb;color:#a397fa">
      ماهانه: {{ displayPricePackage3 }} تومان
    </span>
</div>
                <div @click="showPackage3()"
                  style="display: flex;justify-content: end;margin-top: 10px;text-align: end;cursor: pointer;">
                  <div
                    style="padding:5px;border-radius: 5px;background-color: #E23E57;width:90px;color:white;font-weight: bold;font-size:15px">
                    خرید
                    <i style="padding: 10px;color:white" class="fa-solid fa-angles-left"></i>
                  </div>
                </div>
              </div>
            </div>

            <!-- Card for Package 2 (Featured) -->
            <div               :style="isMobile == true ? 'position:relative;width:100%;margin-top: 35px;display:flex;padding: 10px;background-color: #303030;border-radius: 10px;box-shadow: 2px 2px 4px rgba(black, 0.25);' : 'position:relative;width:100%;margin-top: 35px;display:flex;padding: 10px;background-color: #303030;border-radius: 10px;box-shadow: 2px 2px 4px rgba(black, 0.25);width:400px;height:170px;'">
<span class="badge" style="font-size:15px;font-weight:bold;font-family: IRANSansWeb;color:white">محبوب
  ترین</span>  <img
    :style="isMobile === true ? 'border-radius: 10px;margin-top:13px;width:30vw;height:30vw;margin-right:5px;' : 'border-radius: 10px;margin-top:5px;margin-right:5px;'"
    :src="require('@/assets/img/unlimitedcookie.jpg')" />
  <div style="margin-top:5px;margin-right:15px;width:100%;">
    <div>
      <span style="font-size:17px;font-weight:bold;font-family: IRANSansWeb;color:white">
        معدن کوکی🍪
      </span>
    </div>
    <div style="margin-top: 5px;margin-right:5px">
      <span style="font-size:14px;font-weight:800;font-family: IRANSansWeb;color:white">
        کوکی نامحدود ∞
      </span>
      <p style="font-size:14px;font-weight:800;font-family: IRANSansWeb;color:white">
                    دسترسی با اینترنت ملی
                  </p>
    </div>
    <!-- New pricing display for Package 2 -->
    <div style="margin-top: 10px;display:grid">
      
        <span style="font-size:15px;text-decoration: line-through;color:#ff002b;margin-right:5px;">
          ماهانه: {{ package2Prices[0].toLocaleString() }} تومان
        </span>
        <span style="font-size:17px;font-weight:bold;font-family: IRANSansWeb;color:#a397fa">
          ماهانه: {{ displayPricePackage2 }} تومان
        </span>
    </div>
    <div @click="showPackage2()"
      style="display: flex;justify-content: end;margin-top: 10px;text-align: end;margin-left:5px;cursor: pointer;">
      <div
        style="padding:5px;border-radius: 5px;background-color: #E23E57;width:90px;color:white;font-weight: bold;font-size:15px">
        خرید
        <i style="padding: 10px;color:white" class="fa-solid fa-angles-left"></i>
      </div>
    </div>
  </div>
</div>
          </div>
<br/>
<br/>
<br/>
<br/>


        </div>
      </div>
      <div v-if="isModalApplicationVisible" class="login-box" style="padding:20px;">
        <button style="font-size:20px" @click="closeModal()" id="x">
          <i class="fa-solid fa-times fa-lg" style="color: #ff000d;"></i>
        </button>
        <h2 style="font-weight: bold;font-size:20px">خرید {{ this.plan }} {{ this.selectedPeriod }} ماهه</h2>
        <h5 style="color: white;font-size:15px">
         خرید بسته 12 ماهه در اپلیکیشن روبو ممکن نیست
        </h5>
        <div @click="closeModal()"
            style="display: flex;justify-content: center;margin-top: 10px;text-align: center;margin-left:5px;">
            <div
              style="padding:5px;border-radius: 5px;background-color: #E23E57;width:80vw;color:white;font-weight: bold;font-size:20px">
              تایید
             
            </div>
          </div>
          
      </div>
      <!-- Modal for payment -->
      <div v-if="isModalVisible" class="login-box" style="padding:20px;">
        <button style="font-size:20px" @click="closeModal()" id="x">
          <i class="fa-solid fa-times fa-lg" style="color: #ff000d;"></i>
        </button>
        <h2 style="font-weight: bold;font-size:20px">خرید {{ this.plan }} {{ this.selectedPeriod }} ماهه</h2>
        <h5 v-if="discountDisable == false" style="color: grey;font-size:15px">
          در صورت داشتن کد تحفیف آن را در قسمت پایین وارد کنید
        </h5>
        <div v-if="discountDisable == false" style="display: flex;">
          <div class="user-box" style="margin-left:12px;width:60vw">
            <input v-model="discountCode" style="text-align: center;" type="text" name="" required="">
            <label>کد تخفیف (اختیاری)</label>
          </div>
          <div
            style="text-align:center;padding:12px;width:30vw;border-radius:10px;background-color: #6153cc;height:50px;color:white;cursor: pointer;font-weight: bold;font-size:15px;"
            @click="checkDiscountCode()">
            بررسی
          </div>
        </div>
        <div v-if="this.isApplication">
          <p style="color: rgb(255, 255, 255);font-size:17px">
            مبلغ اشتراک: {{ this.mablagh }} تومان
          </p>
        </div>
        <form>
          <h5 :style="messageColor">{{ messagePaien }}</h5>
          <div v-if="!this.isApplication" @click="makePayment()"
            style="display: flex;justify-content: center;margin-top: 10px;text-align: center;margin-left:5px;">
            <div
              style="padding:5px;border-radius: 5px;background-color: #E23E57;width:80vw;color:white;font-weight: bold;font-size:20px;cursor: pointer;">
              پرداخت {{ this.mablagh }} تومان
              <i style="padding: 10px;color:white" class="fa-solid fa-money-bills"></i>
            </div>
          </div>
          <div v-else @click="buyAndroid()"
            style="display: flex;justify-content: center;margin-top: 10px;text-align: center;margin-left:5px;">
            <div
              style="padding:5px;border-radius: 5px;background-color: #E23E57;width:80vw;color:white;font-weight: bold;font-size:20px">
              پرداخت
              <i style="padding: 10px;color:white" class="fa-solid fa-money-bills"></i>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import router from '@/router';
import axios from 'axios';
import Lottie from 'vue-lottie';
import { notify } from "@kyvg/vue3-notification";
var Timer;
export default {
  name: 'App',
  components: {
    'lottie': Lottie
  },

  data() {
    return {
      isModalVisible: false,
      mablagh: '29,000',
      package: 1,
      discountCode: '',
      messagePaien: '',
      isModalApplicationVisible:false,
      setWidth: (window.innerWidth / 2).toLocaleString(undefined, { maximumFractionDigits: 0 }),
      percent: 0,
      lastCode: '',
      kol: '',
      maliat: '',
      discountDisable: true,
      messageColor: 'color: red',
      plan: 'جعبه کوکی🍪',
      isApplication: navigator.userAgent.match(/ir.roboo.pwa/i) ? true : false,
      isMobile: navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i) ? true : false,
      // New properties for subscription period and package pricing
      selectedPeriod: 1,
      package1Prices: { 0:370000, 1: 298000, 3: 777000, 6: 7130000, 12: 2220000 },
      package2Prices: {0:750000, 1: 598000, 3: 1575000, 6: 10728000, 12: 4500000 },
      package3Prices: {0:600000, 1: 478000, 3: 1260000, 6: 8560800, 12: 3600000 },
    };
  },
  computed: {
    periodLabel() {
      return "ماهانه:";
    },
    displayPricePackage1() {
      return (this.package1Prices[this.selectedPeriod] / this.selectedPeriod)
        .toLocaleString(undefined, { maximumFractionDigits: 0 });
    },
    displayPricePackage2() {
      return (this.package2Prices[this.selectedPeriod] / this.selectedPeriod)
        .toLocaleString(undefined, { maximumFractionDigits: 0 });
    },
    displayPricePackage3() {
      return (this.package3Prices[this.selectedPeriod] / this.selectedPeriod)
        .toLocaleString(undefined, { maximumFractionDigits: 0 });
    }
  },
  methods: {
    setSubscriptionPeriod(period) {
      this.selectedPeriod = period;
    },
    checkDiscountCode() {
      let loading = this.$loading.show({
        isFullPage: true,
        canCancel: false,
        loader: "bars",
        color: "#3e5ada",
        height: "100",
        width: "90",
      });
      axios.get("https://api.roboo.ir/api/Payment/CheckDiscountCode?Code=" + this.discountCode)
        .then(response => {
          loading.hide();
          this.messagePaien = response.data.message;
          if (response.data.status == 0) {
            if (this.package == 1)
              this.mablagh = this.package1Prices[this.selectedPeriod] - ((this.package1Prices[this.selectedPeriod] * response.data.percentage) / 100);
            else if (this.package == 3)
              this.mablagh = this.package3Prices[this.selectedPeriod] - ((this.package3Prices[this.selectedPeriod] * response.data.percentage) / 100);
            else
              this.mablagh = this.package2Prices[this.selectedPeriod] - ((this.package2Prices[this.selectedPeriod] * response.data.percentage) / 100);
            this.kol = (this.mablagh + (this.mablagh * 0.09)).toLocaleString();
            this.mablagh = this.mablagh.toLocaleString();
            this.messageColor = 'color: #00d700';
            this.discountDisable = true;
            this.percent = response.data.percentage;
            this.lastCode = this.discountCode;
          }
          else {
            this.messageColor = 'color: red';
          }
        }).catch(rs => { loading.hide() });
    },
    makePayment() {
      let loadings = this.$loading.show({
        isFullPage: true,
        canCancel: false,
        loader: "bars",
        color: "#3e5ada",
        height: "100",
        width: "90",
      });
      axios
        .post("https://api.roboo.ir/api/Payment/MakePayment?Token=" + localStorage.getItem("token") + "&Package=" + this.package +"&Period=" + this.selectedPeriod + "&DiscountCode=" + this.lastCode)
        .then(response => {
          if (response.data != "") {
            window.location = response.data;
            loadings.hide();
          }
          else {
            notify({
              title: "خطا",
              text: response.data.message,
              type: "error"
            });
          }
        });
    },
    showPackage1() {
      this.package = 1;
      this.plan = "جعبه کوکی🍪";
    //   if(this.selectedPeriod == 12 && this.isApplication == true)
    // {
    //   this.isModalApplicationVisible = true;
    //   document.getElementById('app-menu-content').setAttribute("style", "filter: blur(5px);height:950px;min-height:100%;");
    //   return;
    // }
      this.mablagh = this.package1Prices[this.selectedPeriod].toLocaleString();
      this.kol = this.package1Prices[this.selectedPeriod].toLocaleString();
      this.messagePaien = "";
      this.discountDisable = false;
      this.isModalVisible = true;
      this.lastCode = "";
      this.percent = 0;
      if (this.isApplication)
        this.discountDisable = true;
      document.getElementById('app-menu-content').setAttribute("style", "filter: blur(5px);height:950px;min-height:100%;");
    },
    showPackage2() {
      
      this.package = 2;
      this.plan = "معدن کوکی🍪";
    //   if(this.selectedPeriod == 12 && this.isApplication == true)
    // {
    //   this.isModalApplicationVisible = true;
    //   document.getElementById('app-menu-content').setAttribute("style", "filter: blur(5px);height:950px;min-height:100%;");
    //   return;
    // }
      this.kol = this.package2Prices[this.selectedPeriod].toLocaleString();
      this.mablagh = this.package2Prices[this.selectedPeriod].toLocaleString();
      this.messagePaien = "";
      this.discountDisable = false;
      this.isModalVisible = true;
      this.percent = 0;
      this.lastCode = "";
      document.getElementById('app-menu-content').setAttribute("style", "filter: blur(5px);height:950px;min-height:100%;");
    },
    showPackage3() {
      
      this.package = 3;
      this.plan = "صندوق کوکی🍪";
    //   if(this.selectedPeriod == 12 && this.isApplication == true)
    // {
    //   this.isModalApplicationVisible = true;
    //   document.getElementById('app-menu-content').setAttribute("style", "filter: blur(5px);height:950px;min-height:100%;");
    //   return;
    // }
      this.kol = this.package3Prices[this.selectedPeriod].toLocaleString();
      this.mablagh = this.package3Prices[this.selectedPeriod].toLocaleString();
      this.messagePaien = "";
      this.discountDisable = false;
      this.isModalVisible = true;
      this.percent = 0;
      this.lastCode = "";
      if (this.isApplication)
        this.discountDisable = true;
      document.getElementById('app-menu-content').setAttribute("style", "filter: blur(5px);height:950px;min-height:100%;");
    },
    showModal() {
      this.isModalVisible = true;
      document.getElementById('app-menu-content').setAttribute("style", "filter: blur(5px);height:950px;min-height:100%;");
    },
    buyAndroid() {
      if(this.selectedPeriod == 1)
    {
      if (this.package == 1)
        Android.kharid('plan-1')
      else if (this.package == 3)
        Android.kharid('plan-3')
      else {
        switch (this.percent) {
          case 10:
            Android.kharid('plan-2-10');
            break;
          case 15:
            Android.kharid('plan-2-20');
            break;
          case 20:
            Android.kharid('plan-2-20');
            break;
          case 30:
            Android.kharid('plan-2-30');
            break;
          case 40:
            Android.kharid('plan-2-40');
            break;
          case 50:
            Android.kharid('plan-2-50');
            break;
          case 60:
            Android.kharid('plan-2-60');
            break;
          case 70:
            Android.kharid('plan-2-70');
            break;
          case 80:
            Android.kharid('plan-2-80');
            break;
          default:
            Android.kharid('plan-2');
            break;
        }
      }
      }
      if(this.selectedPeriod == 3)
    {
      if (this.package == 1)
        Android.kharid('plan-1-3')
      else if (this.package == 3)
        Android.kharid('plan-3-3')
      else {
        switch (this.percent) {
          case 10:
            Android.kharid('plan-2-3-10');
            break;
          case 30:
            Android.kharid('plan-2-3-30');
            break;
          case 50:
            Android.kharid('plan-2-3-50');
            break;
          default:
            Android.kharid('plan-2-3');
            break;
        }
      }
      }
    //   if(this.selectedPeriod == 6)
    // {
    //   if (this.package == 1)
    //     Android.kharid('plan-1-6')
    //   else if (this.package == 3)
    //     Android.kharid('plan-3-6')
    //   else {
    //     switch (this.percent) {
    //       case 10:
    //         Android.kharid('plan-2-6-10');
    //         break;
    //       case 30:
    //         Android.kharid('plan-2-6-30');
    //         break;
    //       case 50:
    //         Android.kharid('plan-2-6-50');
    //         break;
    //       default:
    //         Android.kharid('plan-2-6');
    //         break;
    //     }
    //   }
    //   }
      if(this.selectedPeriod == 12)
    {
      if (this.package == 1)
        Android.kharid('plan-1-12')
      else if (this.package == 3)
        Android.kharid('plan-3-12')
      else {
        switch (this.percent) {
          case 10:
            Android.kharid('plan-2-12-10');
            break;
          case 30:
            Android.kharid('plan-2-12-30');
            break;
          case 50:
            Android.kharid('plan-2-12-50');
            break;
          default:
            Android.kharid('plan-2-12');
            break;
        }
      }
      }
    },
    closeModal() {
      this.isModalVisible = false;
      this.isModalApplicationVisible = false;
      document.getElementById('app-menu-content').setAttribute("style", "filter: blur(0px);height:950px;min-height:100%;");
    }
  },
  mounted() {
    console.log(this.setWidth);
    var token = localStorage.getItem("token");
    if (token != null && token != "") {
      if (this.isApplication)
        Android.setToken(token);
    }
    else {
      router.push("login");
    }
    if (this.$route.query.code != null && this.$route.query.code != "") {
      var that = this;
      setTimeout(() => {
        that.showPackage2();
        that.discountCode = this.$route.query.code;
        that.checkDiscountCode();
      }, 1000);
    }
  }
}
</script>

<style lang="scss" scoped>
/* New styles for subscription tabs */
.subscription-tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  margin-top:10px;
}
.tab-button {
  background-color: #303030;
  color: white;
  border: none;
  padding: 10px 20px;
  margin: 0 5px;
  cursor: pointer;
  border-radius: 5px;
  position: relative;
}

/* Highlight active button */
.tab-button.active {
  background-color: #6153cc;
}

/* New discount badge styles */
.discount-badge {
  background-color: #ff5722;
  color: #fff;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: bold;
}

/* Existing styles below remain unchanged */
#app-menu {
  margin-top: 40px;
}

.badge {
  position: absolute;
  top: -25px;
  left: -10px;
  background-color: #6153cc;
  padding: 12px;
  border-radius: 10px 10px 10px 0;
}

.badge:after {
  position: absolute;
  top: 100%;
  left: 0;
  width: 0;
  height: 0;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #6153cc;
  content: '';
}
.circle-div {
  background-color: #6153cc;
  height: 60px;
  width: 90vw;
  border-radius: 10px;
  position: fixed;
  bottom: 15px;
  right: 20px;
}

::placeholder {
  color: rgb(185, 185, 185);
  opacity: 1;
  /* Firefox */
}

::-ms-input-placeholder {
  /* Edge 12 -18 */
  color: rgb(185, 185, 185);
}

.custom {
  filter: blur(10px);
}

@media(min-width: 768px) {
  .login-box {
    top: 50%;
    left: 50%;
    position: fixed;
    width: 30vw;
    padding: 10px;
    transform: translate(-50%, -50%);
    z-index: 100;
    background-color: rgb(24, 24, 24);
    box-sizing: border-box;
    box-shadow: 0 15px 25px rgba(0, 0, 0, .6);
    border-radius: 10px;
  }
}

@media(max-width: 767px) {
  .login-box {
    top: 50%;
    left: 50%;
    position: fixed;
    width: 90vw;
    padding: 10px;
    transform: translate(-50%, -50%);
    z-index: 100;
    background-color: rgb(24, 24, 24);
    box-sizing: border-box;
    box-shadow: 0 15px 25px rgba(0, 0, 0, .6);
    border-radius: 10px;
  }
}

.login-box h2 {
  margin: 0 0 30px;
  padding: 0;
  color: #fff;
  text-align: center;
}

.login-box h5 {
  margin: 0 0 30px;
  padding: 0;
  color: #fff;
  text-align: center;
}

.login-box .user-box {
  position: relative;
  background-color: transparent !important;
}

.login-box .user-box input {
  width: 100%;
  padding: 10px 0;
  font-size: 16px;
  color: #fff;
  margin-bottom: 30px;
  border: none;
  border-bottom: 1px solid #fff;
  outline: none;
  background: transparent;
}

.login-box .user-box label {
  position: absolute;
  top: 0;
  left: 0;
  padding: 10px 0;
  font-size: 16px;
  color: #fff;
  pointer-events: none;
  transition: .5s;
}

.login-box .user-box input:focus~label,
.login-box .user-box input:valid~label {
  top: -20px;
  left: 0;
  color: #7d70e2;
  font-size: 12px;
}

.login-box form a {
  position: relative;
  display: block;
  padding: 10px 20px;
  color: #7d70e2;
  font-size: 16px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  overflow: hidden;
  transition: .5s;
  margin-top: 10px;
  letter-spacing: 4px
}

.login-box a:hover {
  background: #7d70e2;
  color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 5px #7d70e2,
    0 0 25px #7d70e2,
    0 0 50px #7d70e2,
    0 0 100px #7d70e2;
}

.login-box a span {
  position: absolute;
  display: block;
}

.login-box a span:nth-child(1) {
  top: 0;
  left: -100%;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, transparent, #7d70e2);
  animation: btn-anim1 1s linear infinite;
}

@keyframes btn-anim1 {
  0% {
    left: -100%;
  }

  50%,
  100% {
    left: 100%;
  }
}

.login-box a span:nth-child(2) {
  top: -100%;
  right: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(180deg, transparent, #7d70e2);
  animation: btn-anim2 1s linear infinite;
  animation-delay: .25s
}

@keyframes btn-anim2 {
  0% {
    top: -100%;
  }

  50%,
  100% {
    top: 100%;
  }
}

.login-box a span:nth-child(3) {
  bottom: 0;
  right: -100%;
  width: 100%;
  height: 2px;
  background: linear-gradient(270deg, transparent, #7d70e2);
  animation: btn-anim3 1s linear infinite;
  animation-delay: .5s
}

@keyframes btn-anim3 {
  0% {
    right: -100%;
  }

  50%,
  100% {
    right: 100%;
  }
}

.login-box a span:nth-child(4) {
  bottom: -100%;
  left: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(360deg, transparent, #7d70e2);
  animation: btn-anim4 1s linear infinite;
  animation-delay: .75s
}

@keyframes btn-anim4 {
  0% {
    bottom: -100%;
  }

  50%,
  100% {
    bottom: 100%;
  }
}

@font-face {
  font-family: IRANSansWeb;
  src: url('../assets/IRANSansWeb.woff2') format("woff2");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: IRANSansWeb;
  src: url('../assets/IRANSansWebBold.woff2') format("woff2");
  font-weight: bold;
  font-style: normal;
}

span {
  font-family: IRANSansWeb;
  font-weight: bold;
}

@function gray($color) {
  @return rgb($color, $color, $color);
}

$red: rgb(239, 83, 80);
$orange: rgb(255, 160, 0);
$yellow: rgb(253, 216, 53);
$green: rgb(42, 252, 152);
$indigo: rgb(57, 73, 171);
$violet: rgb(103, 58, 183);

/* -- */

$blue: rgb(66, 165, 245);

@keyframes blink {

  from,
  25%,
  to {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(720deg);
  }

  to {
    transform: rotate(1440deg);
  }
}

@keyframes bounce {

  from,
  6.66%,
  17.66%,
  33.33% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0);
  }

  13.33%,
  14.33% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -30px, 0) scaleY(1.1);
  }

  23.33% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -15px, 0) scaleY(1.05);
  }

  26.66% {
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0) scaleY(0.95);
  }

  30% {
    transform: translate3d(0, -4px, 0) scaleY(1.02);
  }
}

body {
  margin: 0px;
  overflow-x: hidden;
  padding: 0px;

  &::-webkit-scrollbar-track {
    background-color: gray(30);
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(white, 0.2);
    border-radius: 100px;
  }

  &::-webkit-scrollbar {
    height: 4px;
    width: 4px;
  }

  input,
  h1,
  h3,
  a,
  span {
    color: gray(90);
    font-family: IRANSansWeb;
    font-weight: bold;
    font-weight: 400;
    margin: 0px;
    padding: 0px;
  }
}

$backgroundImage: "https://images.unsplash.com/photo-1483728642387-6c3bdd6c93e5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2076&q=80";

.background-image {
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.clear-button {
  backdrop-filter: blur(3px);
  background-color: rgba(white, 0.1);
  border: 1px solid rgba(white, 0.1);
  border-radius: 100px;
  box-shadow: 2px 2px 2px rgba(black, 0.1);
  cursor: pointer;

  &:hover {
    background-color: rgba(white, 0.2);
    border: 1px solid rgba(white, 0.3);
  }
}

.text-button {
  backdrop-filter: blur(3px);
  background-color: rgba(white, 0.1);
  border-radius: 15px;
  box-shadow: 2px 2px 2px rgba(black, 0.1);
  cursor: pointer;

  &:hover {
    background-color: rgba(white, 0.2);
    border: 1px solid rgba(white, 0.3);
  }
}

.text-button2 {
  background-color: rgba(white, 0.1);

}

#app {
  background-color: gray(30);

  &.logged-out {
    #app-info {
      margin-left: 40px;
      opacity: 1;
      transform: translateX(0%);
    }

    #app-background {
      cursor: pointer;
    }

    #sign-in-button-wrapper {
      opacity: 1;
      pointer-events: all;
      transform: translate(-50%, -40px);
    }
  }

  &.logging-in,
  &.verifying-log-in,
  &.log-in-error {
    #app-background {
      #app-background-image {
        filter: blur(8px);
        transform: scale(1.2);
      }
    }
  }

  &.logging-in,
  &.log-in-error {
    #app-pin-wrapper {
      opacity: 1;
      pointer-events: all;
      transform: translate(-50%, -50%) scale(1);
    }
  }

  &.verifying-log-in {
    #app-loading-icon {
      opacity: 1;
      transform: translate(-50%, -50%);
    }
  }

  &.log-in-error {
    #app-pin-wrapper {
      #app-pin {
        .app-pin-digit {
          background-color: rgba($red, 0.05);
          border-color: rgba($red, 0.5);
        }
      }
    }
  }

  &.logged-in {
    #app-menu {
      opacity: 1;
      pointer-events: all;
    }
  }

  .scrollable-component {
    cursor: grab;
    overflow: auto;
    user-select: none;
    width: 100%;

    &:active {
      cursor: grabbing;
    }

    &::-webkit-scrollbar {
      height: 0px;
      width: 0px;
    }
  }

  #app-loading-icon {
    left: 50%;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translate(-50%, 0%);
    transition: opacity 250ms, transform 250ms;
    z-index: 2;

    i {
      animation: 2s spin ease-in-out infinite;
      color: white;
      font-size: 2em;
    }
  }

  #app-background {
    height: 100%;
    left: 0px;
    overflow: hidden;
    position: fixed;
    top: 0px;
    width: 100%;
    z-index: 1;

    #app-background-image {
      height: 100%;
      transition: filter 250ms, transform 250ms;
      width: 100%;
    }
  }

  #app-info {
    bottom: 0px;
    left: 0px;
    margin: 40px;
    margin-left: 0px;
    opacity: 0;
    position: absolute;
    transform: translateX(-100%);
    transition: margin 250ms, opacity 250ms, transform 250ms;
    z-index: 2;
  }

  .user-status-button {
    cursor: pointer;
    margin-top: 10px;
    outline: none;
    padding: 10px;
    width: 100px;

    i {
      color: gray(245);
      font-size: 1.25em;
    }
  }

  #sign-in-button-wrapper {
    bottom: 0px;
    left: 50%;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    transform: translate(-50%, 40px);
    transition: opacity 250ms, transform 250ms;
    z-index: 2;

    #sign-in-button {
      &:not(:hover) {
        animation: bounce 3s infinite;
        animation-delay: 3s;
      }
    }
  }

  .info {
    align-items: flex-end;
    display: flex;

    .time {
      color: gray(245);
      font-size: 6em;
      height: 80px;
      line-height: 80px;
      text-shadow: 2px 2px 2px rgba(black, 0.1);
    }

    .weather {
      display: inline-flex;
      height: 20px;
      margin-bottom: 6px;
      margin-left: 20px;

      i,
      span {
        align-items: center;
        display: inline-flex;
      }

      i {
        color: $yellow;
        font-size: 0.9em;
      }

      span {
        color: white;
      }

      .weather-type {
        height: 20px;
      }

      .weather-temperature-value {
        font-size: 1.5em;
        height: 20px;
        margin-left: 5px;
      }

      .weather-temperature-unit {
        align-items: flex-start;
        font-size: 0.8em;
        margin-left: 3px;
      }
    }
  }

  .reminder {
    display: flex;
    gap: 6px;
    margin-top: 10px;

    i,
    div {
      display: inline-flex;
    }

    i {
      color: gray(245);
      font-size: 0.8em;
      height: 12px;
      line-height: 12px;
    }

    span {
      color: rgba(white, 0.8);
      font-size: 1.1em;
    }

    .reminder-icon {
      align-items: center;
      height: 20px;
    }

    .reminder-time {
      align-items: flex-end;
      color: gray(30);
      font-size: 0.8em;
      height: 20px;
    }
  }

  #quick-nav {
    display: flex;
    gap: 10px;
    margin-top: 20px;
    overflow: auto;
    padding-bottom: 5px;
    width: 100%;
    z-index: 3;

    .quick-nav-item {
      padding: 10px 20px;

      &:last-of-type {
        margin-right: 10px;
      }

      .quick-nav-item-label {
        color: gray(245);
        text-shadow: 0px 0px 2px rgba(black, 0.1);
      }
    }
  }

  #youtube-link {
    align-items: center;
    display: inline-flex;
    gap: 5px;
    margin-top: 10px;
    padding: 10px 20px;
    text-decoration: none;

    i,
    span {
      height: 20px;
      line-height: 20px;
    }

    i {
      color: $red;
    }

    span {
      color: white;
    }
  }

  .menu-section {
    margin-top: 20px;

    .menu-section-title {
      align-items: center;
      display: flex;
      gap: 6px;

      i,
      span {
        color: gray(245);
      }

      i {
        font-size: 1em;
      }

      .menu-section-title-text {
        color: rgba(white, 0.9);
        font-size: 1.4em;
        font-weight: bold;
      }
    }

    .menu-section-content {
      margin-top: 15px;
      padding-top: 5px;
    }
  }

  #restaurants-section {
    .menu-section-content {
      display: flex;
      gap: 1em;

      .restaurant-card {
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        cursor: pointer;
        height: 14vw;
        max-height: 240px;
        position: relative;
        transition: transform 250ms;
        width: 25%;

        &:hover {
          transform: translateY(-5px);

          .restaurant-card-content {
            .restaurant-card-content-items {
              margin-bottom: 30px;
            }
          }
        }

        .restaurant-card-content {
          background: linear-gradient(to top, rgba(black, 0.8), transparent);
          border-radius: 10px;
          height: 100%;
          width: 100%;

          .restaurant-card-content-items {
            bottom: 0px;
            display: flex;
            flex-direction: column;
            margin: 20px;
            position: absolute;
            right: 0px;
            text-align: right;
            transition: margin 250ms;

            .restaurant-card-title {
              color: gray(245);
              font-size: 1.5em;
            }

            .restaurant-card-desc {
              color: $blue;
              font-size: 0.9em;
            }
          }
        }
      }
    }
  }

  #weather-section {
    .menu-section-content {
      display: flex;
      gap: 1em;
      padding: 5px 0px;
      width: 100%;

      .day-card {
        backdrop-filter: blur(3px);
        background-color: rgba(white, 0.1);
        border: 1px solid rgba(white, 0.2);
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        height: 8vw;
        max-height: 160px;
        min-height: 140px;
        min-width: 180px;
        position: relative;
        transition: transform 250ms;
        width: calc(100% / 7);

        &:last-of-type {
          margin-right: 5px;
        }

        .day-card-content {
          display: flex;
          flex-direction: column;
          height: calc(100% - 20px);
          justify-content: space-evenly;
          padding: 10px;

          i,
          span {
            color: gray(245);
            text-align: center;
          }

          .day-weather-temperature {
            align-items: flex-start;
            display: flex;
            font-size: 0.9em;
            justify-content: center;

            .day-weather-temperature-unit {
              font-size: 0.8em;
              margin-left: 3px;
            }
          }

          .day-weather-icon {
            font-size: 3.5em;
            text-shadow: 2px 2px 2px rgba(black, 0.1);

            &.sunny {
              color: $yellow;
            }

            &.rainy,
            &.stormy {
              color: $blue;
            }
          }

          .day-name {
            font-size: 0.9em;
            text-transform: uppercase;
          }
        }
      }
    }
  }

  #tools-section {
    .menu-section-content {
      display: flex;
      gap: 1em;
      width: 100%;
      height: 60vh;

      .tool-card {
        background-color: gray(30);
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        cursor: pointer;
        height: vw;
        max-height: 220px;
        min-height: 180px;
        min-width: 1;

        position: relative;
        transition: transform 250ms;
        width: calc(100% / 6);

        &:hover {
          transform: translateY(-5px);

          .tool-card-background {
            filter: grayscale(0);
          }
        }

        .tool-card-background {
          border-radius: 10px;
          height: 100%;
          left: 0px;
          position: absolute;
          top: 0px;
          transition: filter 250ms;
          width: 100%;
        }

        .tool-card-content {
          display: flex;

          i,
          span {
            color: gray(245);
            position: absolute;
            width: 100%;
            height: 60%;

          }

          .tool-card-content-header {
            display: flex;
            flex-direction: column;
            gap: 2px;



          }

          .tool-card-icon {
            color: gray(245);
            font-size: 2em;
          }
        }
      }
    }
  }

  #movies-section {
    .menu-section-content {
      display: flex;
      gap: 1em;

      #movie-card-1 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($indigo, 0.4), transparent, rgba(black, 0.4));
        }
      }

      #movie-card-2 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($violet, 0.4), transparent, rgba(black, 0.4));
        }
      }

      #movie-card-3 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($red, 0.4), transparent, rgba(black, 0.4));
        }
      }

      #movie-card-4 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($green, 0.4), rgba(black, 0.1), rgba(black, 0.4));
        }
      }

      .movie-card {
        background-color: gray(30);
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        cursor: pointer;
        height: 40vw;
        max-height: 250px;
        min-height: 200px;
        min-width: 200px;
        overflow: hidden;
        position: relative;
        transition: transform 250ms;
        width: calc(100% / 4);

        &:hover {
          transform: translateY(-5px);

          .movie-card-background {
            transform: scale(1.05);
          }

          .movie-card-content {
            i {
              transform: translate(-20%, -20%) scale(1.2);
            }
          }
        }

        .movie-card-background {
          border-radius: 10px;
          height: 100%;
          left: 0px;
          position: absolute;
          top: 0px;
          transition: transform 250ms;
          width: 100%;
          z-index: 1;
        }

        .movie-card-content {
          background: linear-gradient(to top, rgba(black, 0.5), rgba(black, 0.1), rgba(black, 0.4));
          border-radius: 10px;
          height: 100%;
          position: relative;
          z-index: 2;

          .movie-card-info {
            display: flex;
            flex-direction: column;
            gap: 5px;
            padding: 30px;

            span {
              text-shadow: 2px 2px 2px rgba(black, 0.1);
            }

            .movie-card-title {
              color: gray(245);
              font-size: 1.5em;
              font-weight: bold;
            }

            .movie-card-desc {
              color: gray(200);
              font-size: 0.9em;
            }
          }

          i {
            bottom: 0px;
            color: gray(245);
            font-size: 5em;
            padding: 30px;
            position: absolute;
            right: 0px;
            text-shadow: 2px 2px 2px rgba(black, 0.1);
            transition: transform 250ms;
          }
        }
      }
    }
  }

  #app-pin-wrapper {
    left: 50%;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -30%) scale(0.8);
    transition: opacity 250ms, transform 250ms;
    z-index: 2;

    #app-pin-label {
      color: gray(245);
      font-size: 0.9em;
      margin: 10px;
      text-shadow: 2px 2px 2px rgba(black, 0.1);

      #app-pin-cancel-text {
        cursor: pointer;
        margin-left: 2px;

        &:hover {
          text-decoration: underline;
        }
      }

      #app-pin-error-text {
        color: $red;
      }
    }

    #app-pin-hidden-input {
      background-color: transparent;
      border: none;
      height: 0px;
      outline: none;
      pointer-events: none;
      position: absolute;
      width: 0px;
    }

    #app-pin {
      display: flex;
      gap: 10px;

      .app-pin-digit {
        align-items: center;
        background-color: rgba(white, 0.05);
        border: 1px solid rgba(white, 0.2);
        border-radius: 10px;
        box-shadow: 2px 2px 2px rgba(black, 0.06);
        display: inline-flex;
        font-size: 3em;
        height: 80px;
        justify-content: center;
        position: relative;
        transition: background-color 250ms, border-color 250ms;
        width: 60px;

        &:after,
        &:before {
          box-shadow: 2px 2px 2px rgba(black, 0.06);
          content: "";
          position: absolute;
          transition: opacity 250ms, transform 250ms;
          z-index: 2;
        }

        &:before {
          background-color: gray(245);
          border-radius: 10px;
          bottom: 0px;
          height: 3px;
          left: 15%;
          opacity: 0;
          transform: translateY(0px);
          width: 70%;
        }

        &:after {
          background-color: gray(245);
          border-radius: 20px;
          height: 20px;
          opacity: 0;
          transform: scale(0.25);
          width: 20px;
        }

        &.focused {
          &:before {
            animation: blink 2s ease-in-out infinite;
            opacity: 1;
            transform: translateY(-10px);
          }
        }

        &.hidden {
          &:after {
            opacity: 1;
            transform: scale(1);
          }

          .app-pin-digit-value {
            opacity: 0;
            transform: scale(0.25);
          }
        }

        .app-pin-digit-value {
          color: gray(245);
          transition: opacity 250ms, transform 250ms;
        }
      }
    }
  }

  #app-menu {
    overflow: hidden;
    opacity: 0;
    pointer-events: none;
    position: relative;
    transition: opacity 250ms, transform 250ms;
    z-index: 2;

    #app-menu-content-wrapper {
      background: #212529;
      min-height: 100vh;
      padding: 50px;
      padding-top: 0px;

      #app-menu-content {
        margin: auto;
        max-width: 1600px;
        position: relative;

        #app-menu-content-header {
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
}

@media(max-width: 1300px) {
  #app {
    &.logged-out {
      #sign-in-button-wrapper {
        transform: translate(-40px, 0px);
      }
    }

    #sign-in-button-wrapper {
      bottom: 40px;
      left: auto;
      right: 0px;
      transform: translate(40px, 0px);
    }

    #app-menu {
      #app-menu-content-wrapper {
        padding: 20px;

        #app-menu-content {
          #restaurants-section {
            .menu-section-content {
              flex-wrap: wrap;

              .restaurant-card {
                height: 22vh;
                ;
                max-height: 300px;
                position: relative;
                width: calc(50% - 0.5em);
              }
            }
          }

          #tools-section {
            .menu-section-content {

              .tool-card {
                width: 50vw;
              }
            }
          }
        }
      }
    }
  }
}

@media(max-width: 600px) {
  #app {
    .info {
      .time {
        font-size: 4em;
        height: 60px;
        line-height: 60px;
      }
    }

    .user-status-button {
      width: 60px;
    }

    #app-menu {
      #app-menu-content-wrapper {
        #app-menu-content {
          #restaurants-section {
            .menu-section-content {
              flex-direction: column;

              .restaurant-card {
                height: 40vw;
                position: relative;
                width: 100%;
              }
            }
          }

          #tools-section {
            .menu-section-content {

              .tool-card {
                width: 50vw;
              }
            }
          }
        }
      }
    }
  }
}

@media(max-width: 400px) {
  #app {
    #app-menu {
      #app-menu-content-wrapper {
        #app-menu-content {
          #tools-section {
            .menu-section-content {

              .tool-card {
                width: 50vw;
              }
            }
          }
        }
      }
    }
  }
}

.overflow2 {
  margin: 0 0 0 0;
  text-overflow: ellipsis;
  width: 82vw;
  /**
   * Required properties to achieve text-overflow
   */
  white-space: nowrap;
  overflow: hidden;
}

.overflow {
  margin: 0 0 2em 0;
  text-overflow: ellipsis;
  /**
   * Required properties to achieve text-overflow
   */
  white-space: nowrap;
  overflow: hidden;
}
</style>